import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { assetsAPI } from '../../services/api';
import toast from 'react-hot-toast';
import { fmtMoney } from '../../utils/currency';
const fmt = fmtMoney;
export default function AssetList() {
  const navigate = useNavigate(); const [assets, setAssets] = useState([]); const [loading, setLoading] = useState(true);
  const load = () => assetsAPI.list({}).then(setAssets).catch(e=>toast.error(e.message)).finally(()=>setLoading(false));
  useEffect(() => { load(); }, []);
  const handleDepreciate = async(id) => { try { await assetsAPI.depreciate(id); toast.success('Depreciation posted'); load(); } catch(e) { toast.error(e.message); } };
  return (
    <div>
      <div className="toolbar"><h2>Fixed Assets</h2>
        <div className="toolbar-right"><button className="btn btn-primary" onClick={()=>navigate('/assets/new')}>+ New Asset</button></div>
      </div>
      {loading ? <div className="spinner" style={{margin:'40px auto'}} /> : (
        <div className="card"><div className="card-body" style={{padding:0}}>
          <table><thead><tr><th>#</th><th>Name</th><th>Category</th><th>Purchase Date</th><th className="text-right">Cost</th><th className="text-right">Accum. Depr.</th><th className="text-right">Book Value</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>{assets.map(a=>{const bv=parseFloat(a.purchase_cost)-parseFloat(a.accumulated_depreciation||0);return (<tr key={a.id}>
              <td className="font-mono">{a.asset_number}</td><td><strong>{a.name}</strong></td><td>{a.category_name||'-'}</td><td>{a.purchase_date}</td>
              <td className="amount">{fmt(a.purchase_cost)}</td><td className="amount">{fmt(a.accumulated_depreciation)}</td><td className="amount">{fmt(bv)}</td>
              <td><span className={`badge badge-${a.status==='Active'?'posted':a.status==='Disposed'?'voided':'draft'}`}>{a.status}</span></td>
              <td>{a.status==='Active'&&<button className="btn btn-sm btn-outline" onClick={()=>handleDepreciate(a.id)}>Depreciate</button>}</td>
            </tr>);})}
            {assets.length===0 && <tr><td colSpan={9} className="text-center text-muted" style={{padding:30}}>No fixed assets</td></tr>}
          </tbody></table>
        </div></div>
      )}
    </div>
  );
}
